var exports = {
  "bZ": "Testimonials__aI2Mbi",
  "eH": "Testimonials__quotes__44PLu4",
  "_L": "Testimonials__group__vx6wkJ",
  "OT": "Testimonials__stats__dHqq-6",
  "rL": "Testimonials__stat__Mnxlqt",
  "K3": "Testimonials__statValue__GX4gx-",
};

module.exports = exports;
